import React, { useEffect, useState } from "react";
import styles from "./formCategory.module.css";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import TextField from "component/textField/TextField";
import LabeledSelect from "component/select/labeledSelect/LabeledSelect";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import ValidationMessage from "component/validationMessage/ValidationMessage";
import PhoneNumberInput from "component/phoneNumberInput/PhoneNumberInput";
import AppDatePicker from "component/inputs/datePicker/DatePicker";
const maritalStatus = [
  {
    label: "Single",
    value: "single",
  },
  {
    label: "Married",
    value: "married",
  },
  {
    label: "Divorced",
    value: "divorce",
  },
];

const genders = [
  {
    label: "Male",
    value: "male",
  },
  {
    label: "Female",
    value: "female",
  },
];

function ApplicationDetails({
  trigger,
  watch,
  formData,
  setValue,
  errors,
  register,
}) {
  const dob = watch("dob", "");
  useEffect(() => {
    if (formData.phone) {
      trigger("phone");
    }
  }, [formData.phone]);

  return (
    <div className={styles.category_tab}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={4}>
          <div className={styles.category}>
            <Typography variant="h6">Application Details</Typography>
            <Typography>
              Details of the individual making the application.
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} sm={8}>
          <div className={styles.category_form}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <TextField
                    setValue={setValue}
                    watch={watch}
                    textValidation
                    required={true}
                    name="firstName"
                    register={register}
                    errors={errors}
                    label="First Name"
                    type="text"
                    placeholder="First Name"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <TextField
                    setValue={setValue}
                    watch={watch}
                    textValidation
                    required={true}
                    name="lastName"
                    register={register}
                    errors={errors}
                    label="Last Name"
                    type="text"
                    placeholder="Last Name"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <TextField
                    textValidation
                    setValue={setValue}
                    watch={watch}
                    name="middleName"
                    register={register}
                    errors={errors}
                    label="Middle Name"
                    type="text"
                    placeholder="Middle Name"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <LabeledSelect
                    required={true}
                    name="gender"
                    data={genders}
                    register={register}
                    errors={errors}
                    label="Gender"
                    placeholder="Select Gender"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <TextField
                    required={true}
                    name="netSalary"
                    register={register}
                    errors={errors}
                    label="Net Salary"
                    type="number"
                    placeholder="Net Salary"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <AppDatePicker
                    required={true}
                    errors={errors}
                    name="dob"
                    label="Date of Birth"
                    setValue={setValue}
                    value={dob}
                    trigger={trigger}
                  />
                  {/* <TextField
                    required={true}
                    dateMax={true}
                    name="dob"
                    register={register}
                    errors={errors}
                    label="Date of Birth"
                    type="date"
                    placeholder="Date of Birth"
                  /> */}
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <TextField
                    required={true}
                    name="email"
                    register={register}
                    errors={errors}
                    readOnly
                    label="Email Address"
                    type="text"
                    placeholder="Email Address"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <PhoneNumberInput
                    value={formData.phone}
                    name="phone"
                    errors={errors}
                    setValue={setValue}
                  />
                  {/* <TextField
                    required={true}
                    name="phone"
                    register={register}
                    errors={errors}
                    label="Phone Number"
                    type="text"
                    placeholder="Phone Number"
                  /> */}
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <LabeledSelect
                    required={true}
                    data={maritalStatus}
                    name="maritalStatus"
                    register={register}
                    errors={errors}
                    label="Marital Status"
                    placeholder="Marital Status"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <LabeledSelect
                    name="employmentType"
                    data={[
                      {
                        label: "Employed",
                        value: "employed",
                      },
                      {
                        label: "Self Employed",
                        value: "self_employed",
                      },
                    ]}
                    register={register}
                    errors={errors}
                    label="Employment Type"
                    placeholder="Select Employment Type"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default ApplicationDetails;